import { FirebaseInfoFieldVisibility } from "./DataObjectHelpers/Property/InfoFields/InfoFieldTypes";

export class FirebaseInfoField<T> {
  value?: T | undefined = undefined;
  suffix?: string;
  loaded: boolean = false;
  visibility: FirebaseInfoFieldVisibility[] = [];

  constructor(value: T | undefined, rawData?: { [key: string]: any }) {
    this.value = value;
    //const field = DataObjectHelpers.property.getField(key);

    if (typeof rawData === "object") {
      if (typeof rawData.suffix === "string") {
        this.suffix = rawData.suffix;
      }
      if (Array.isArray(rawData.visibility)) {
        this.visibility = rawData.visibility;
      }
    }
  }
}
